import { useCallback } from 'react';

export const useSignUpOnboarding = () => {
  const isOnboardingStarted = useCallback(
    () => !!localStorage.getItem('onboardingCompleted'),
    []
  );
  const isOnboardingCompleted = useCallback(
    () =>
      localStorage.getItem('onboardingCompleted') &&
      localStorage.getItem('onboardingCompleted') === 'true',
    []
  );
  const onOnboardingStarted = useCallback(() => {
    if (!localStorage.getItem('onboardingCompleted')) {
      localStorage.setItem('onboardingCompleted', 'false');
    }
  }, []);
  const onOnboardingCompleted = useCallback(() => {
    localStorage.setItem('onboardingCompleted', 'true');
  }, []);

  return {
    isOnboardingCompleted,
    isOnboardingStarted,
    onOnboardingCompleted,
    onOnboardingStarted,
  };
};
